import { render, staticRenderFns } from "./ResumePage.vue?vue&type=template&id=0a3f6c2d"
import script from "./ResumePage.vue?vue&type=script&lang=js"
export * from "./ResumePage.vue?vue&type=script&lang=js"
import style0 from "./ResumePage.vue?vue&type=style&index=0&id=0a3f6c2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports